import { createFileRoute } from '@tanstack/react-router';
import { RoutePlaceholder } from './-components/RoutePlaceholder';

export const Route = createFileRoute('/profile/settings')({
  component: () => (
    <RoutePlaceholder
      icon="settings"
      title="Settings"
      description="Profile details, limits and preferences."
    />
  ),
});
